import { render, staticRenderFns } from "./ReviewPlaceholderPanel.vue?vue&type=template&id=4af8bcf1&scoped=true&"
import script from "./ReviewPlaceholderPanel.vue?vue&type=script&lang=js&"
export * from "./ReviewPlaceholderPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af8bcf1",
  null
  
)

export default component.exports